import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { License } from 'src/models/license.model';

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  baseUrl = environment.apiUrl + 'CompanyLicense/';

  constructor(private http: HttpClient) {}
  save(license: License): Observable<any> {
    return this.http.post(this.baseUrl + `save`, license);
  }

  isAuthorized(id): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `is-authorized?companyId=${id}`);
  }

  getLicenseByCompany(id): Observable<License> {
    return this.http.get<License>(this.baseUrl + `by-company?companyId=${id}`);
  }

  isExpired(id): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `is-expired?companyId=${id}`);
  }
}
